import React from 'react'
import { Oval } from 'react-loading-icons'

import './Loading.css'
const Loading = () => {
  return (
    <div className='loading'>
      <Oval />
    </div>
  )
}

export default Loading